/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M21 19.5C17 19.5 15 20 12 22C9 20 7 19.5 3 19.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 18C14.4268 16.4399 16.2646 16.0156 18.7998 15.9002C19.9707 15.8469 20.5562 15.8203 20.9643 15.5957C21.3343 15.3921 21.6076 15.106 21.7942 14.7271C22 14.3093 22 13.7586 22 12.6571V2C17.5556 2 15.3333 2 12 4.14286M12 18C9.57324 16.4399 7.7354 16.0156 5.20023 15.9002C4.02927 15.8469 3.44379 15.8203 3.03575 15.5957C2.66572 15.3921 2.39236 15.106 2.20576 14.7271C2 14.3093 2 13.7586 2 12.6571V2C6.44444 2 8.66667 2 12 4.14286M12 18V4.14286"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M22 2V12.6571C22 13.7586 22 14.3093 21.7942 14.7271C21.6076 15.106 21.3343 15.3921 20.9643 15.5957C20.5562 15.8203 19.9707 15.8469 18.7998 15.9002C16.2646 16.0156 14.4268 16.4399 12 18C9.57324 16.4399 7.7354 16.0156 5.20023 15.9002C4.02927 15.8469 3.44379 15.8203 3.03575 15.5957C2.66572 15.3921 2.39236 15.106 2.20576 14.7271C2 14.3093 2 13.7586 2 12.6571V2C6.44444 2 8.66667 2 12 4.14286C15.3333 2 17.5556 2 22 2Z"
				fill="currentColor"
			/>
			<path
				d="M12 18C14.4268 16.4399 16.2646 16.0156 18.7998 15.9002C19.9707 15.8469 20.5562 15.8203 20.9643 15.5957C21.3343 15.3921 21.6076 15.106 21.7942 14.7271C22 14.3093 22 13.7586 22 12.6571V2C17.5556 2 15.3333 2 12 4.14286M12 18C9.57324 16.4399 7.7354 16.0156 5.20023 15.9002C4.02927 15.8469 3.44379 15.8203 3.03575 15.5957C2.66572 15.3921 2.39236 15.106 2.20576 14.7271C2 14.3093 2 13.7586 2 12.6571V2C6.44444 2 8.66667 2 12 4.14286M12 18V4.14286M21 19.5C17 19.5 15 20 12 22C9 20 7 19.5 3 19.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.2065 1.35502C21.9935 1.24571 21.7123 1.24458 21.15 1.24232C19.5779 1.236 18 1.25792 16.4538 1.52901C16.0981 1.59138 15.7497 1.66744 15.4043 1.75978C14.7337 1.9391 14.3983 2.02876 13.9246 2.392C13.5814 2.65517 13.1441 3.22469 12.9785 3.62425C12.75 4.17575 12.75 4.68234 12.75 5.69552V9.99989C12.75 10.4141 12.4142 10.7499 12 10.7499C11.5858 10.7499 11.25 10.4141 11.25 9.99989V5.69552C11.25 4.68234 11.25 4.17575 11.0215 3.62425C10.8559 3.22469 10.4186 2.65517 10.0754 2.392C9.60165 2.02876 9.26632 1.9391 8.59568 1.75978C8.25035 1.66744 7.90193 1.59138 7.54618 1.52901C5.99997 1.25792 4.42208 1.236 2.84998 1.24232C2.28768 1.24458 2.00654 1.24571 1.7935 1.35502C1.60561 1.45142 1.45409 1.60355 1.35845 1.79183C1.25 2.0053 1.25 2.28683 1.25 2.84989V11.807C1.25 13.3974 1.25 14.1926 1.5397 14.803C1.81132 15.3754 2.17112 15.7706 2.71551 16.0947C3.29615 16.4403 4.2131 16.5266 6.04701 16.6992C6.46239 16.7383 6.87605 16.7915 7.28715 16.8636C8.70571 17.1123 10.0018 17.6069 11.5944 18.6308L12 18.8915L12.4056 18.6308C13.9982 17.6069 15.2943 17.1123 16.7129 16.8636C17.1239 16.7915 17.5376 16.7383 17.953 16.6992C19.7869 16.5266 20.7039 16.4403 21.2845 16.0947C21.8289 15.7706 22.1887 15.3754 22.4603 14.803C22.75 14.1926 22.75 13.3974 22.75 11.807V2.84989C22.75 2.28683 22.75 2.0053 22.6416 1.79183C22.5459 1.60355 22.3944 1.45142 22.2065 1.35502ZM3 18.7499C2.58578 18.7499 2.25 19.0857 2.25 19.4999C2.25 19.9141 2.58578 20.2499 3 20.2499C4.97376 20.2499 6.39687 20.3742 7.67766 20.7235C8.95055 21.0706 10.1262 21.6521 11.584 22.6239C11.8359 22.7919 12.1641 22.7919 12.416 22.6239C13.8738 21.6521 15.0494 21.0706 16.3223 20.7235C17.6031 20.3742 19.0262 20.2499 21 20.2499C21.4142 20.2499 21.75 19.9141 21.75 19.4999C21.75 19.0857 21.4142 18.7499 21 18.7499C18.9738 18.7499 17.3969 18.8756 15.9277 19.2763C14.585 19.6425 13.3686 20.2282 12 21.1039C10.6314 20.2282 9.41498 19.6425 8.07234 19.2763C6.60313 18.8756 5.02623 18.7499 3 18.7499Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 18C14.4268 16.4399 16.2646 16.0156 18.7998 15.9002C19.9707 15.8469 20.5562 15.8203 20.9643 15.5957C21.3343 15.3921 21.6076 15.106 21.7942 14.7271C22 14.3093 22 13.7586 22 12.6571V2C19.2638 2 17.3699 2 15.5404 2.5C15.3599 2.54934 15.18 2.60355 15 2.6631M12 18C9.57324 16.4399 7.7354 16.0156 5.20023 15.9002C4.02927 15.8469 3.44379 15.8203 3.03575 15.5957C2.66572 15.3921 2.39236 15.106 2.20576 14.7271C2 14.3093 2 13.7586 2 12.6571V2C6.44444 2 8.66667 2 12 4.14286V18ZM21 19.5C17 19.5 15 20 12 22C9 20 7 19.5 3 19.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 18C14.4268 16.4399 16.2646 16.0156 18.7998 15.9002C19.9707 15.8469 20.5562 15.8203 20.9643 15.5957C21.3343 15.3921 21.6076 15.106 21.7942 14.7271C22 14.3093 22 13.7586 22 12.6571V2C17.5556 2 15.3333 2 12 4.14286M12 18C9.57324 16.4399 7.7354 16.0156 5.20023 15.9002C4.02927 15.8469 3.44379 15.8203 3.03575 15.5957C2.66572 15.3921 2.39236 15.106 2.20576 14.7271C2 14.3093 2 13.7586 2 12.6571V2C6.44444 2 8.66667 2 12 4.14286M12 18V4.14286M21 19.5C17 19.5 15 20 12 22C9 20 7 19.5 3 19.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 3.2581C10.4311 2.30401 9.05461 1.79347 7.54619 1.52901C5.99997 1.25792 4.42208 1.236 2.84998 1.24232C2.28768 1.24458 2.00654 1.24571 1.7935 1.35502C1.60561 1.45142 1.45409 1.60355 1.35845 1.79183C1.25 2.0053 1.25 2.28683 1.25 2.84989V11.807C1.25 13.3974 1.25 14.1926 1.5397 14.803C1.81132 15.3754 2.17112 15.7706 2.71551 16.0947C3.29615 16.4403 4.2131 16.5266 6.04701 16.6992C6.46239 16.7383 6.87606 16.7915 7.28715 16.8636C9.02109 17.1676 10.5345 17.9494 12 18.8915L12 3.2581Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 3.25834C13.5689 2.30425 14.9454 1.79372 16.4538 1.52926C18 1.25817 19.5779 1.23624 21.15 1.24256C21.7123 1.24483 21.9935 1.24596 22.2065 1.35526C22.3944 1.45166 22.5459 1.60379 22.6416 1.79207C22.75 2.00555 22.75 2.28707 22.75 2.85013V11.8073C22.75 13.3976 22.75 14.1928 22.4603 14.8033C22.1887 15.3756 21.8289 15.7709 21.2845 16.0949C20.7039 16.4406 19.7869 16.5269 17.953 16.6995L17.953 16.6995C17.5376 16.7386 17.1239 16.7918 16.7129 16.8639C14.9789 17.1679 13.4655 17.9496 12 18.8917V3.25834ZM3 18.75C2.58579 18.75 2.25 19.0858 2.25 19.5C2.25 19.9142 2.58579 20.25 3 20.25C4.97377 20.25 6.39687 20.3743 7.67766 20.7236C8.95056 21.0707 10.1262 21.6522 11.584 22.624C11.8359 22.792 12.1641 22.792 12.416 22.624C13.8738 21.6522 15.0494 21.0707 16.3223 20.7236C17.6031 20.3743 19.0262 20.25 21 20.25C21.4142 20.25 21.75 19.9142 21.75 19.5C21.75 19.0858 21.4142 18.75 21 18.75C18.9738 18.75 17.3969 18.8757 15.9277 19.2764C14.585 19.6426 13.3686 20.2283 12 21.1041C10.6314 20.2283 9.41499 19.6426 8.07234 19.2764C6.60313 18.8757 5.02623 18.75 3 18.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
